import React from 'react'
import Hero from '../components/Hero'
import { textsection_two } from '../data/TextsectionData'
import TextSection from '../components/TextSection'
import TextwithImage from '../components/TextwithImage'
import { textSections } from '../data/TextwithimageData'
import Card from '../components/Card'
import {features_four, features_three, features_two } from '../data/CardData'
import CardSection from '../components/CardSection'
import { featureContentData_two } from '../data/CardSectionData'
import { useNavigate } from 'react-router-dom'

const Platform = () => {
    const navigate = useNavigate();
    return(
    <>
    <Hero
      title="One platform to manage your entire workforce, from hire to retire."
      description="Empower your global hiring with a platform that simplifies workforce management, ensuring seamless operations worldwide."
      buttonText=""
      customClass="platformBanner"
      imageSrc=""
      squareColor="platformsquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
    <TextSection  data={textsection_two} withSpan={false}/>
    <div className="wrapper">
        <div className="four_card_container">
            <Card features={features_two} customClass='four_card'/>
        </div>    
    </div>    
    <TextwithImage data={textSections.pageTwo} />
    <CardSection data={featureContentData_two} featuress={features_four} customClass="platform_card"/>
    <div className="wrapper">
        <div className="six_card_container">
            <h1>Why Choose Our US Workforce Management Technology</h1>
            <Card features={features_three} customClass='six_card'/>
        </div>    
    </div> 
    <Hero
      title="Want to see how our platform can transform your global operations?"
      description="Unlock global potential with our Workforce Management Technology. Book a complimentary demo with one of our global expansion experts today!."
      buttonText="Speak to our Experts "
      customClass = "platformbackBanner"
      buttonBgColor="platformback-button-bg-color"
      imageSrc="images/aihero5.webp"
      squareColor="platformbacksquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
    
    </>
    )
}

export default Platform